@if (!isDynamicdashboard) {
  <h2><a [ecommerceRouterLink]="['/:lang/shop/orders']"><mibp-resource-string key="Dashboard_LatestOrders"></mibp-resource-string></a></h2>
}

@if (orders?.length > 0 && !isLoading) {
  <ul>
    @for (order of orders; track order.id) {
      <li>
        <div class="line"></div>
        <div class="order">
          <a [ecommerceRouterLink]="['/:lang/shop/orders/' + order.id ]">
            <mibp-resource-string key="Global_Order"></mibp-resource-string>
            #{{ order.number }}
            <mibp-resource-string [key]="'Carts_OrderStatus_' + order.status"></mibp-resource-string><br>
          </a>
          {{ order.grandTotal | formatPrice }} {{ order.currencyCode }}
        </div>
      </li>
    }
  </ul>
}

@if (isLoading) {
  <mibp-loader></mibp-loader>
}

@if (hasError) {
  <div class="my-discreet-error">
    <p><mibp-resource-string key="Global_Error_DataCouldNotBeLoaded"></mibp-resource-string></p>
    <p><a href="javascript:void(0)" (click)="load()"><mibp-resource-string key="Global_Action_TryAgain"></mibp-resource-string></a></p>
  </div>
}

